import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { IoNavigate } from "react-icons/io5";
import { Attachment, Dashboard, Home } from "@mui/icons-material";
import ViewTimelineIcon from "@mui/icons-material/ViewTimeline";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import QuizIcon from "@mui/icons-material/Quiz";
import InsightsIcon from "@mui/icons-material/Insights";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import PropTypes, { oneOfType } from "prop-types";
import { GiArtificialIntelligence } from "react-icons/gi";

export function PrevIcon(props) {
  return <NavigateBeforeIcon color="primary" {...props} />;
}

export function NextIcon(props) {
  return <NavigateNextIcon color="primary" {...props} />;
}

export function NavigateIcon(props) {
  return <IoNavigate color="primary" {...props} />;
}

export function KotiIcon(props) {
  return <Home {...props} />;
}

export function GPTIcon({ fontSize }) {
  return <GiArtificialIntelligence fontSize={fontSize} />;
}
GPTIcon.propTypes = {
  fontSize: oneOfType([PropTypes.string, PropTypes.number]),
};

export function GridIcon(props) {
  return <ViewTimelineIcon {...props} />;
}
export function DashboardIcon(props) {
  return <Dashboard {...props} />;
}
export function ReportIcon(props) {
  return <LocalLibraryIcon {...props} />;
}
export function LomaIcon(props) {
  return <LocalBarIcon {...props} />;
}
export function GraphIcon(props) {
  return <InsightsIcon {...props} />;
}
export function ListIcon(props) {
  return <FormatListBulletedIcon {...props} />;
}
export function AttachmentIcon(props) {
  return <Attachment {...props} />;
}
export function DeAttachIcon(props) {
  return <LinkOffIcon {...props} />;
}
export function LogIcon(props) {
  return <LocalLibraryIcon {...props} />;
}
export function TestIcon(props) {
  return <QuizIcon {...props} />;
}
